<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Indicadores eSB"
            description=""
            url="/dashboard"
          />
        </div>
      </div>
      <div class="grid-itens">
        <div v-for="(item, index) in cards" :key="index" class="item-flex">
          <router-link :to="item.link">
            <div class="item">
              <i v-if="item.icone !== false" :class="item.icone"></i>
              <img v-else-if="item.imagem !== ''" :src="item.imagem" alt="" />
              <component v-else :is="item.svg" />
              <h3>
                {{ item.titulo }}
              </h3>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'
import Ampliados from '@/components/icons/IndicadoresEsb/Ampliados'
import Estrategicos from '@/components/icons/IndicadoresEsb/Estrategicos'

export default {
  name: 'IndicadoresEsb',
  components: {
    Menu,
    Footer,
    SectionTitle,
    Ampliados,
    Estrategicos,
  },
  computed: {
    cards() {
      return this.$store.state?.permissoes?.indicadores_esb
    },
  },
  data() {
    return {}
  },
}
</script>

<style></style>
